import { useMutation } from 'react-query';
import request from '../helpers/request';
import { recordsActions } from '../actions/records.actions';

const bindCallsByRequest = async (body) => {
  return await request.post(
    `/Phone/bind_call_to_request`,
    body,
    'При прикреплении звонка к заявке произошла ошибка',
    'Error'
  );
};

const useBindCallsByRequest = () => {
  const mutation = useMutation(bindCallsByRequest, {
    onSuccess: (data, { requestId }) => {
      if (data !== 'Error') {
        recordsActions.fetchRecords(requestId);
      }
    },
  });

  return {
    isLoading: mutation.isLoading,
    onBindCallsByRequest: mutation.mutateAsync,
  };
};

export default useBindCallsByRequest;
